/* ===== ETERNALLÉ THEME — MAIN.JS v2 ===== */

document.addEventListener('DOMContentLoaded', function () {

  /* ══════════════════════════════════════════
     HEADER SCROLL SHADOW
  ══════════════════════════════════════════ */
  const header = document.getElementById('SiteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ══════════════════════════════════════════
     MOBILE MENU
  ══════════════════════════════════════════ */
  const mobileToggle  = document.getElementById('MobileMenuToggle');
  const mobileMenu    = document.getElementById('MobileMenu');
  const mobileClose   = document.getElementById('MobileMenuClose');
  const mobileOverlay = document.getElementById('MobileMenuOverlay');

  function openMobileMenu() {
    mobileMenu && mobileMenu.classList.add('open');
    mobileOverlay && mobileOverlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu && mobileMenu.classList.remove('open');
    mobileOverlay && mobileOverlay.classList.remove('show');
    document.body.style.overflow = '';
  }
  mobileToggle  && mobileToggle.addEventListener('click', openMobileMenu);
  mobileClose   && mobileClose.addEventListener('click', closeMobileMenu);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileMenu);

  /* ══════════════════════════════════════════
     PRODUCT IMAGE GALLERY (unlimited + fast)
  ══════════════════════════════════════════ */
  const mainImg      = document.getElementById('MainProductImage');
  const loadOverlay  = document.getElementById('ImageLoadingOverlay');
  const thumbBtns    = document.querySelectorAll('#ProductThumbnails .thumbnail');

  // Preload images on hover for instant switch
  thumbBtns.forEach(btn => {
    btn.addEventListener('mouseenter', function () {
      const src = this.dataset.src;
      if (src) {
        const preloader = new Image();
        preloader.src = src;
      }
    });

    btn.addEventListener('click', function () {
      const src = this.dataset.src;
      if (!mainImg || !src || mainImg.src.includes(src.split('?')[0])) return;

      // Show loading overlay briefly
      if (loadOverlay) loadOverlay.classList.add('loading');

      const newImg = new Image();
      newImg.onload = function () {
        mainImg.src = src;
        if (loadOverlay) loadOverlay.classList.remove('loading');
      };
      newImg.onerror = function () {
        mainImg.src = src; // fallback: set anyway
        if (loadOverlay) loadOverlay.classList.remove('loading');
      };
      newImg.src = src;

      thumbBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ══════════════════════════════════════════
     VARIANT SELECTOR
  ══════════════════════════════════════════ */
  const variantInput  = document.getElementById('ProductVariantId');
  const variantBtns   = document.querySelectorAll('.variant-btn');
  const variantLabel = document.getElementById('SelectedVariantLabel');

  variantBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      variantBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      if (variantInput) variantInput.value = this.dataset.variantId;
      if (variantLabel) variantLabel.textContent = this.textContent.trim();
    });
  });

  /* ══════════════════════════════════════════
     PRODUCT ACCORDION
  ══════════════════════════════════════════ */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const content  = this.nextElementSibling;

      document.querySelectorAll('.accordion-trigger').forEach(t => {
        t.setAttribute('aria-expanded', 'false');
        const c = t.nextElementSibling;
        if (c) c.hidden = true;
      });

      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        if (content) content.hidden = false;
      }
    });
  });

  /* ══════════════════════════════════════════
     FAQ ACCORDION
  ══════════════════════════════════════════ */
  document.querySelectorAll('.faq-trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const answer   = this.nextElementSibling;

      document.querySelectorAll('.faq-trigger').forEach(t => {
        t.setAttribute('aria-expanded', 'false');
        const a = t.nextElementSibling;
        if (a) a.hidden = true;
      });

      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        if (answer) answer.hidden = false;
      }
    });
  });

  /* ══════════════════════════════════════════
     CART DRAWER
  ══════════════════════════════════════════ */
  const cartDrawer        = document.getElementById('CartDrawer');
  const cartDrawerOverlay = document.getElementById('CartDrawerOverlay');
  const cartDrawerClose   = document.getElementById('CartDrawerClose');
  const cartDrawerBody    = document.getElementById('CartDrawerBody');
  const cartDrawerFooter  = document.getElementById('CartDrawerFooter');
  const cartDrawerCount   = document.getElementById('CartDrawerCount');
  const cartCountHeader   = document.getElementById('CartCount');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartDrawerOverlay && cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  cartDrawerClose   && cartDrawerClose.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCartDrawer();
  });

  // Open drawer when clicking cart icon in header
  const cartIconLink = document.querySelector('.cart-icon');
  if (cartIconLink) {
    cartIconLink.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  async function fetchCart() {
    const resp = await fetch('/cart.js');
    return resp.json();
  }

   let activeCurrency = 'EUR';

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: activeCurrency }).format(cents / 100);
  }


  // Umbral de envío gratis — 30€, en céntimos
  const FREE_SHIPPING_THRESHOLD = 3000;

  function renderShippingBar(totalPrice) {
    const remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
    const percent = Math.min(100, Math.round((totalPrice / FREE_SHIPPING_THRESHOLD) * 100));

    if (remaining <= 0) {
      return `
        <div class="cart-shipping-bar unlocked">
          <p class="cart-shipping-msg">
            <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            ¡Envío GRATIS conseguido!
          </p>
          <div class="cart-shipping-track"><div class="cart-shipping-fill" style="width:100%;"></div></div>
        </div>`;
    }

    return `
      <div class="cart-shipping-bar">
        <p class="cart-shipping-msg">Te faltan ${formatMoney(remaining)} para el envío GRATIS</p>
        <div class="cart-shipping-track"><div class="cart-shipping-fill" style="width:${percent}%;"></div></div>
      </div>`;
  }

  function renderCartDrawer() {
    if (!cartDrawerBody) return;
    cartDrawerBody.innerHTML = '<div class="drawer-spinner"></div>';
    if (cartDrawerFooter) cartDrawerFooter.innerHTML = '';

    fetchCart().then(cart => {
            activeCurrency = cart.currency || 'EUR';
      updateCartBadges(cart.item_count);

      if (cart.item_count === 0) {
        cartDrawerBody.innerHTML = `
          <div class="cart-drawer-empty">
            <svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 24 24">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 01-8 0"/>
            </svg>
            <p>Tu cesta está vacía</p>
            <a href="/collections/all" onclick="closeCartDrawer()">Seguir comprando</a>
          </div>`;
        cartDrawerFooter.innerHTML = '';
        return;
      }

      const shippingBarHTML = renderShippingBar(cart.total_price);

      cartDrawerBody.innerHTML = shippingBarHTML + cart.items.map(item => `
        <div class="drawer-item" data-key="${item.key}">
          <div class="drawer-item-img">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
          </div>
          <div class="drawer-item-info">
            <div class="drawer-item-title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title'
              ? `<div class="drawer-item-variant">${item.variant_title}</div>` : ''}
            <div class="drawer-item-row">
              <div class="drawer-qty">
                <button class="drawer-qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease">−</button>
                <span class="drawer-qty-val">${item.quantity}</span>
                <button class="drawer-qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase">+</button>
              </div>
              <span class="drawer-item-price">${formatMoney(item.line_price)}</span>
            </div>
          </div>
          <button class="drawer-item-remove" data-key="${item.key}" aria-label="Remove item">
            <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>
      `).join('');

      cartDrawerFooter.innerHTML = `
  <div style="background:#1a1a1a; color:#fff; padding:10px 16px; display:flex; align-items:center; gap:8px; font-size:12px; font-weight:600; margin: 0 calc(var(--spacing-6) * -1); margin-top: calc(var(--spacing-4) * -1);">
    🚚 Entrega estimada: 4–6 días laborales
  </div>
  <div style="padding: 14px 0 4px;">
    <div style="display:flex; justify-content:space-between; font-size:13px; padding: 6px 0; border-bottom:1px solid var(--color-gray-200);">
      <span>Garantía de 90 días</span><span style="font-weight:700;">GRATIS</span>
    </div>
    <div style="display:flex; justify-content:space-between; font-size:13px; padding: 6px 0; border-bottom:1px solid var(--color-gray-200);">
      <span>Envío con seguimiento exprés</span><span style="font-weight:700;">GRATIS</span>
    </div>
    <div style="display:flex; justify-content:space-between; font-size:13px; padding: 6px 0; border-bottom:1px solid var(--color-gray-200);">
      <span>Regalos Incluidos (valor +45€)</span><span style="font-weight:700;">GRATIS</span>
    </div>
  </div>
  <div class="drawer-subtotal" style="margin-top:10px;">
    <span class="drawer-subtotal-label">Total</span>
    <span class="drawer-subtotal-price">${formatMoney(cart.total_price)}</span>
  </div>
  <a href="/checkout" class="btn btn-primary btn-full btn-lg drawer-checkout-btn">Finalizar Compra</a>
`;


      // Bind continue btn
      const contBtn = document.getElementById('DrawerContinueBtn');
      if (contBtn) contBtn.addEventListener('click', closeCartDrawer);

      // Qty buttons
      cartDrawerBody.querySelectorAll('.drawer-qty-btn').forEach(btn => {
        btn.addEventListener('click', async function () {
          const key    = this.dataset.key;
          const action = this.dataset.action;
          const qty    = parseInt(this.dataset.qty, 10);
          const newQty = action === 'increase' ? qty + 1 : qty - 1;

          this.disabled = true;
          await updateCartItem(key, newQty);
          renderCartDrawer();
        });
      });

      // Remove buttons
      cartDrawerBody.querySelectorAll('.drawer-item-remove').forEach(btn => {
        btn.addEventListener('click', async function () {
          await updateCartItem(this.dataset.key, 0);
          renderCartDrawer();
        });
      });
    }).catch(err => {
      console.error('Cart fetch error:', err);
      cartDrawerBody.innerHTML = '<p style="padding:1rem;text-align:center;color:#757575;">Could not load cart. Please refresh.</p>';
    });
  }

  async function updateCartItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  }

  function updateCartBadges(count) {
    if (cartCountHeader) cartCountHeader.textContent = count;
    if (cartDrawerCount) {
      cartDrawerCount.textContent = count;
      cartDrawerCount.style.display = count > 0 ? 'inline-flex' : 'none';
    }
  }

  /* ══════════════════════════════════════════
     ADD TO CART — AJAX + OPEN DRAWER
  ══════════════════════════════════════════ */
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = this.querySelector('.add-to-cart');
      const originalHTML = btn ? btn.innerHTML : '';

      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span class="drawer-spinner" style="width:18px;height:18px;border-width:2px;display:inline-block;vertical-align:middle;margin-right:6px;"></span>Adding...';
      }

      try {
        const formData = new FormData(this);
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!resp.ok) {
          const err = await resp.json();
          throw new Error(err.description || 'Error adding to cart');
        }

        // Success — open drawer
        openCartDrawer();

        if (btn) {
          btn.innerHTML = '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg> Added!';
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 2000);
        }

      } catch (err) {
        console.error(err);
        alert(err.message || 'Could not add to cart. Please try again.');
        if (btn) {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }
      }
    });
  }

  /* ══════════════════════════════════════════
     SCROLL REVEAL
  ══════════════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll(
      '.stat-item, .ingredient-card, .hiw-step, .review-card, .benefit-item, .no-harsh-img-wrap'
    );
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    revealEls.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = `opacity 0.5s ease ${i * 0.06}s, transform 0.5s ease ${i * 0.06}s`;
      observer.observe(el);
    });
  }

  /* ══════════════════════════════════════════
     STICKY ADD TO CART BAR
  ══════════════════════════════════════════ */
  const addToCartBtn = document.querySelector('.add-to-cart');
  const stickyBar    = createStickyBar();

  if (addToCartBtn && stickyBar) {
    const obs = new IntersectionObserver(entries => {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(addToCartBtn);
  }

  function createStickyBar() {
    if (!document.querySelector('.product-hero-top')) return null;
    const bar = document.createElement('div');
    bar.className = 'sticky-atc-bar';
    bar.innerHTML = `
      <div class="container">
        <div class="sticky-atc-inner">
          <div class="sticky-product-name">
            <span class="stars" style="font-size:0.85rem;">★★★★★</span>
            <strong id="StickyProductTitle"></strong>
          </div>
          <button class="btn btn-primary sticky-atc-btn" id="StickyAtcBtn">Add to Cart</button>
        </div>
      </div>`;
    document.body.appendChild(bar);

    const titleEl    = document.querySelector('.product-title');
    const stickyTitle = bar.querySelector('#StickyProductTitle');
    if (titleEl && stickyTitle) stickyTitle.textContent = titleEl.textContent.trim();

    const stickyBtn = bar.querySelector('#StickyAtcBtn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const mainBtn = document.querySelector('.add-to-cart');
        if (mainBtn) mainBtn.click();
      });
    }
    return bar;
  }

  /* ══════════════════════════════════════════
     REVIEWS PAGINATION (UI)
  ══════════════════════════════════════════ */
  document.querySelectorAll('.reviews-page-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.reviews-page-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ══════════════════════════════════════════
     SMOOTH ANCHOR SCROLL
  ══════════════════════════════════════════ */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ══════════════════════════════════════════
     INIT — load cart count on page load
  ══════════════════════════════════════════ */
  fetchCart().then(cart => updateCartBadges(cart.item_count)).catch(() => {});

});
